/**
 * dados_do_cliente.js (loja 24534 — desktop e mobile, arquivo idêntico nos dois temas)
 *
 * 1. Visitante não logado: intercepta os botões de compra e pede nome, e-mail,
 *    telefone e CPF num modal antes de adicionar ao carrinho. Os dados ficam no
 *    localStorage (não pede de novo nesse navegador). Depois do modal o botão segue
 *    o fluxo normal (sidebar de "adicionado" / checkout), sem redirecionar.
 * 2. Depois de cada add-to-cart que deu certo, grava os dados no pedido via
 *    POST /cart/customer/identify — uma vez por cart_token (de novo só se o carrinho
 *    ou algum dado mudar). Falha no identify nunca bloqueia a compra.
 * 3. Cliente logado (#HD_LVCLI_ID): nem modal nem identify.
 * 4. Página de produto: esconde a descrição de título "Especificações".
 *
 * Substitui os scripts do painel (cart-interceptor-sync.js, que lia o customerData da v2,
 * e o ocultarEspecificacoes com MutationObserver).
 *
 * Botões suportados:
 *   <a class="button-second" href="javascript:void(wsFuncBtBuyOnList(...))">
 *   <button class="button-second" onclick="wsFuncBtBuy(...)">
 */

(function () {
  "use strict";

  var MODAL_ID    = "cli-data-modal";
  var SENT_KEY    = "cliIdentifySent"; // { ct, sig } do último identify aceito
  var TITULO_OCULTO = "especificações";

  // Guarda a ação pendente do botão clicado: { type: "href"|"onclick", code: "..." }
  var _acaoPendente = null;

  function lsGet(k) { try { return localStorage.getItem(k) || ""; } catch (e) { return ""; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function digitos(v) { return String(v || "").replace(/\D/g, ""); }

  function clienteLogado() {
    var el = document.getElementById("HD_LVCLI_ID");
    var id = el && el.value ? el.value.trim() : "";
    return !!id && id !== "0";
  }

  /* ───────────────────────────────────────────
     1. Dados do cliente no localStorage
  ─────────────────────────────────────────── */
  function lerDados() {
    return {
      nome:     lsGet("cliNome").trim(),
      email:    lsGet("cliEmail").trim(),
      telefone: lsGet("cliTelefone").trim(),
      cpf:      lsGet("cliCPF").trim(),
    };
  }

  // Valida o que está guardado, não só a presença: o script da v2 gravava
  // "00000000000" no telefone/CPF — esses visitantes precisam preencher de verdade.
  function telefoneValido(tel) {
    var n = digitos(tel);
    return n.length >= 10 && !/^(\d)\1+$/.test(n);
  }

  function dadosCompletos() {
    var d = lerDados();
    return !!d.nome && validarEmail(d.email) && telefoneValido(d.telefone) && validarCPF(d.cpf);
  }

  /* ───────────────────────────────────────────
     2. POST /cart/customer/identify após o add-to-cart
  ─────────────────────────────────────────── */
  function enviarIdentify() {
    if (clienteLogado() || !dadosCompletos()) return;

    var ct = lsGet("orderIdKeepTC_B").trim();
    if (!ct) return;

    var d = lerDados();
    var body = {
      store_id:   Number(ApiWS.LV) || ApiWS.LV,
      cart_token: ct,
      name:       d.nome,
      mail:       d.email,
      phone:      digitos(d.telefone),
      document:   digitos(d.cpf),
    };
    var sig = [body.name, body.mail, body.phone, body.document].join("|");

    var enviado = null;
    try { enviado = JSON.parse(lsGet(SENT_KEY) || "null"); } catch (e) {}
    if (enviado && enviado.ct === ct && enviado.sig === sig) return;

    ApiWS.Calls._post("/cart/customer/identify", body)
      .then(function (res) {
        if (res && res.result === "success") {
          lsSet(SENT_KEY, JSON.stringify({ ct: ct, sig: sig }));
        } else {
          console.warn("[dados_do_cliente] identify não aceito:", res && res.message);
        }
      })
      .catch(function (e) {
        console.warn("[dados_do_cliente] identify falhou:", e);
      });
  }

  // Envolve ApiWS.Calls.cartAddItem (ponto único de todo add-to-cart da v3): o pedido só
  // existe depois do primeiro add, então o identify só pode ir depois dele.
  function instalarHookAddToCart() {
    if (typeof ApiWS === "undefined" || !ApiWS.Calls || typeof ApiWS.Calls.cartAddItem !== "function") return false;
    if (ApiWS.Calls.cartAddItem.__cliIdentify) return true;

    var original = ApiWS.Calls.cartAddItem;
    var comHook = function (args) {
      return original.apply(this, arguments).then(function (data) {
        try {
          if (data && data.result === "success" && !(args && args.isGift)) enviarIdentify();
        } catch (e) {
          console.warn("[dados_do_cliente] identify falhou:", e);
        }
        return data;
      });
    };
    comHook.__cliIdentify = true;
    ApiWS.Calls.cartAddItem = comHook;
    return true;
  }

  /* ───────────────────────────────────────────
     3. Executa o código original do botão
  ─────────────────────────────────────────── */
  function executarAcao(acao) {
    if (!acao || !acao.code) return;

    var code = acao.code.trim();

    // Para href: remove "javascript:" e "void(...)"
    if (acao.type === "href") {
      if (code.indexOf("javascript:") === 0) {
        code = code.substring("javascript:".length).trim();
      }
      var voidMatch = code.match(/^void\s*\(([\s\S]*)\)\s*$/);
      if (voidMatch) {
        code = voidMatch[1].trim();
      }
    }

    try {
      // eslint-disable-next-line no-new-func
      (new Function(code))();
    } catch (e) {
      console.warn("[dados_do_cliente] Erro ao executar ação:", e);
    }
  }

  /* ───────────────────────────────────────────
     4. Identifica se o elemento é um botão de compra
        Retorna o objeto de ação { type, code } ou null
  ─────────────────────────────────────────── */
  function identificarBotao(el) {
    if (!el || !el.classList || !el.classList.contains("button-second")) {
      return null;
    }

    if (
      el.tagName === "A" &&
      el.getAttribute("href") &&
      el.getAttribute("href").indexOf("wsFuncBtBuyOnList") !== -1
    ) {
      return { type: "href", code: el.getAttribute("href") };
    }

    if (
      el.tagName === "BUTTON" &&
      el.getAttribute("onclick") &&
      el.getAttribute("onclick").indexOf("wsFuncBtBuy") !== -1
    ) {
      return { type: "onclick", code: el.getAttribute("onclick") };
    }

    return null;
  }

  /* ───────────────────────────────────────────
     5. Cria o HTML do modal via JS
  ─────────────────────────────────────────── */
  function criarModal() {
    if (document.getElementById(MODAL_ID)) return;

    var overlay = document.createElement("div");
    overlay.id = MODAL_ID;
    overlay.className = "cli-modal-overlay";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.setAttribute("aria-labelledby", "cli-modal-title");

    var card = document.createElement("div");
    card.className = "cli-modal-card";

    var icon = document.createElement("div");
    icon.className = "cli-modal-icon";
    icon.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>' +
      '<circle cx="12" cy="7" r="4"/>' +
      "</svg>";

    var titulo = document.createElement("h2");
    titulo.id = "cli-modal-title";
    titulo.className = "cli-modal-title";
    titulo.textContent = "Identificação do Cliente";

    var sub = document.createElement("p");
    sub.className = "cli-modal-subtitle";
    sub.textContent = "Para seguir com a compra, por favor informe os dados abaixo.";

    var formWrap = document.createElement("div");
    formWrap.className = "cli-modal-form";

    var salvos = lerDados();
    var campos = [
      { id: "cli-input-nome",     label: "Nome completo",       type: "text",  placeholder: "Seu nome",        valor: salvos.nome },
      { id: "cli-input-email",    label: "E-mail",              type: "email", placeholder: "seu@email.com",   valor: salvos.email },
      { id: "cli-input-telefone", label: "Telefone / WhatsApp", type: "tel",   placeholder: "(00) 00000-0000", valor: telefoneValido(salvos.telefone) ? salvos.telefone : "" },
      { id: "cli-input-cpf",      label: "CPF",                 type: "text",  placeholder: "000.000.000-00",  valor: validarCPF(salvos.cpf) ? salvos.cpf : "" },
    ];

    campos.forEach(function (c) {
      var grupo = document.createElement("div");
      grupo.className = "cli-field-group";

      var lbl = document.createElement("label");
      lbl.setAttribute("for", c.id);
      lbl.textContent = c.label;

      var inp = document.createElement("input");
      inp.type = c.type;
      inp.id = c.id;
      inp.placeholder = c.placeholder;
      inp.autocomplete = "off";
      if (c.valor) inp.value = c.valor;

      var err = document.createElement("span");
      err.className = "cli-field-error";
      err.setAttribute("aria-live", "polite");

      grupo.appendChild(lbl);
      grupo.appendChild(inp);
      grupo.appendChild(err);
      formWrap.appendChild(grupo);
    });

    var btn = document.createElement("button");
    btn.id = "cli-btn-continuar";
    btn.className = "cli-btn-continuar";
    btn.type = "button";
    btn.textContent = "Continuar";

    var spinner = document.createElement("span");
    spinner.className = "cli-spinner";
    btn.appendChild(spinner);

    btn.addEventListener("click", handleSubmit);

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) fecharModal();
    });

    overlay.addEventListener("keydown", function (e) {
      if (e.key === "Escape") fecharModal();
      if (e.key === "Enter" && e.target.tagName === "INPUT") handleSubmit();
    });

    overlay.addEventListener("input", function (e) {
      if (e.target.id === "cli-input-telefone") aplicarMascaraTelefone(e.target);
      if (e.target.id === "cli-input-cpf")      aplicarMascaraCPF(e.target);
    });

    var header = document.createElement("div");
    header.className = "cli-modal-header";
    header.appendChild(icon);
    header.appendChild(titulo);
    header.appendChild(sub);

    var body = document.createElement("div");
    body.className = "cli-modal-body";
    body.appendChild(formWrap);

    var footer = document.createElement("div");
    footer.className = "cli-modal-footer";
    footer.appendChild(btn);

    card.appendChild(header);
    card.appendChild(body);
    card.appendChild(footer);
    overlay.appendChild(card);
    document.body.appendChild(overlay);
  }

  /* ───────────────────────────────────────────
     6. Abre / fecha o modal
  ─────────────────────────────────────────── */
  function abrirModal(acao) {
    _acaoPendente = acao || null;
    criarModal();
    var overlay = document.getElementById(MODAL_ID);
    requestAnimationFrame(function () {
      overlay.classList.add("cli-modal-open");
      var primeiro = overlay.querySelector("input");
      if (primeiro) setTimeout(function () { primeiro.focus(); }, 100);
    });
    document.body.classList.add("cli-modal-body-lock");
  }

  function fecharModal() {
    var overlay = document.getElementById(MODAL_ID);
    if (!overlay) return;
    overlay.classList.remove("cli-modal-open");
    document.body.classList.remove("cli-modal-body-lock");
    setTimeout(function () {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }, 320);
  }

  /* ───────────────────────────────────────────
     7. Máscaras de input
  ─────────────────────────────────────────── */
  function aplicarMascaraTelefone(el) {
    var v = el.value.replace(/\D/g, "").substring(0, 11);
    if (v.length > 10) {
      el.value = "(" + v.substring(0,2) + ") " + v.substring(2,7) + "-" + v.substring(7);
    } else if (v.length > 6) {
      el.value = "(" + v.substring(0,2) + ") " + v.substring(2,6) + "-" + v.substring(6);
    } else if (v.length > 2) {
      el.value = "(" + v.substring(0,2) + ") " + v.substring(2);
    } else if (v.length > 0) {
      el.value = "(" + v;
    }
  }

  function aplicarMascaraCPF(el) {
    var v = el.value.replace(/\D/g, "").substring(0, 11);
    if (v.length > 9) {
      el.value = v.substring(0,3) + "." + v.substring(3,6) + "." + v.substring(6,9) + "-" + v.substring(9);
    } else if (v.length > 6) {
      el.value = v.substring(0,3) + "." + v.substring(3,6) + "." + v.substring(6);
    } else if (v.length > 3) {
      el.value = v.substring(0,3) + "." + v.substring(3);
    } else {
      el.value = v;
    }
  }

  /* ───────────────────────────────────────────
     8. Validações
  ─────────────────────────────────────────── */
  function validarEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function validarCPF(cpf) {
    var nums = digitos(cpf);
    if (nums.length !== 11 || /^(\d)\1+$/.test(nums)) return false;
    var soma = 0, resto;
    for (var i = 1; i <= 9; i++) soma += parseInt(nums[i - 1]) * (11 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(nums[9])) return false;
    soma = 0;
    for (var j = 1; j <= 10; j++) soma += parseInt(nums[j - 1]) * (12 - j);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    return resto === parseInt(nums[10]);
  }

  function setErro(inputId, msg) {
    var inp = document.getElementById(inputId);
    var err = inp && inp.parentNode.querySelector(".cli-field-error");
    if (inp) inp.classList.toggle("cli-input-error", !!msg);
    if (err) err.textContent = msg || "";
  }

  function validarForm() {
    var nome     = (document.getElementById("cli-input-nome")     || {}).value || "";
    var email    = (document.getElementById("cli-input-email")    || {}).value || "";
    var telefone = (document.getElementById("cli-input-telefone") || {}).value || "";
    var cpf      = (document.getElementById("cli-input-cpf")      || {}).value || "";

    var ok = true;

    if (nome.trim().split(" ").length < 2 || nome.trim().length < 5) {
      setErro("cli-input-nome", "Informe o nome completo.");
      ok = false;
    } else { setErro("cli-input-nome", ""); }

    if (!validarEmail(email.trim())) {
      setErro("cli-input-email", "E-mail inválido.");
      ok = false;
    } else { setErro("cli-input-email", ""); }

    if (!telefoneValido(telefone)) {
      setErro("cli-input-telefone", "Telefone inválido.");
      ok = false;
    } else { setErro("cli-input-telefone", ""); }

    if (!validarCPF(cpf)) {
      setErro("cli-input-cpf", "CPF inválido.");
      ok = false;
    } else { setErro("cli-input-cpf", ""); }

    return ok ? { nome: nome.trim(), email: email.trim(), telefone: telefone.trim(), cpf: cpf.trim() } : null;
  }

  /* ───────────────────────────────────────────
     9. Submit: salva → executa a ação original do botão
        (o próprio botão abre a sidebar de "adicionado"; o identify sai
        pelo hook do cartAddItem quando o add der certo)
  ─────────────────────────────────────────── */
  function handleSubmit() {
    var dados = validarForm();
    if (!dados) return;

    lsSet("cliNome",     dados.nome);
    lsSet("cliEmail",    dados.email);
    lsSet("cliTelefone", dados.telefone);
    lsSet("cliCPF",      dados.cpf);

    fecharModal();

    var acao = _acaoPendente;
    _acaoPendente = null;
    instalarHookAddToCart();
    executarAcao(acao);
  }

  /* ───────────────────────────────────────────
     10. Intercepta cliques nos botões de compra
  ─────────────────────────────────────────── */
  function interceptarBotoes() {
    document.addEventListener("click", function (e) {
      var el = e.target;

      while (el && el !== document) {
        var acao = identificarBotao(el);

        if (acao) {
          if (!clienteLogado() && !dadosCompletos()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            // O stopImmediatePropagation impede o listener que grava o card clicado
            // (wsapi3-prod-template-rules) — grava aqui pro wsFuncBtBuyOnList ler a
            // quantidade do card certo.
            var card = el.closest && el.closest("[ws-prod-id]");
            if (card) window.__wsListBuyCard = card;
            abrirModal(acao);
          }
          return;
        }

        el = el.parentNode;
      }
    }, true); // capture: pega antes dos listeners originais da loja
  }

  /* ───────────────────────────────────────────
     11. Página de produto: sem a descrição "Especificações"
         - SSR: <h2>Especificações</h2><div>…</div> direto no container → removidos
           aqui (o script roda no fim do body, com o HTML já parseado).
         - Client: filtra no normalize.product, antes de o pag-produto montar.
  ─────────────────────────────────────────── */
  function tituloOculto(t) {
    return String(t || "").replace(/<[^>]*>/g, "").trim().toLowerCase() === TITULO_OCULTO;
  }

  function filtrarEspecificacoes() {
    if (typeof ApiWS === "undefined" || !ApiWS.Calls || !ApiWS.Calls.normalize) return;
    var normalize = ApiWS.Calls.normalize;
    if (typeof normalize.product !== "function" || normalize.product.__cliSemEspec) return;

    var original = normalize.product;
    var semEspec = function () {
      var p = original.apply(this, arguments);
      if (p && Array.isArray(p.descricoes)) {
        p.descricoes = p.descricoes.filter(function (d) { return !tituloOculto(d && d.titulo); });
      }
      return p;
    };
    semEspec.__cliSemEspec = true;
    normalize.product = semEspec;
  }

  function removerEspecificacoesSsr() {
    var container = document.getElementById("prod-description-container");
    if (!container) return;
    Array.prototype.slice.call(container.querySelectorAll("h2")).forEach(function (h2) {
      if (!tituloOculto(h2.textContent)) return;
      // Formato do client: <div>[<label>]<h2/>…</div> — remove o filho direto do container.
      var bloco = h2;
      while (bloco.parentNode && bloco.parentNode !== container) bloco = bloco.parentNode;
      if (bloco !== h2) { container.removeChild(bloco); return; }
      var conteudo = h2.nextElementSibling;
      if (conteudo && conteudo.tagName === "DIV") container.removeChild(conteudo);
      container.removeChild(h2);
    });
  }

  /* ───────────────────────────────────────────
     12. Init
  ─────────────────────────────────────────── */
  filtrarEspecificacoes();
  removerEspecificacoesSsr();
  if (!clienteLogado()) instalarHookAddToCart();

  function init() {
    filtrarEspecificacoes();
    removerEspecificacoesSsr();
    if (clienteLogado()) return;
    instalarHookAddToCart();
    interceptarBotoes();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
